(function () {
  function init(root) {
    var progress = root.querySelector('[data-kit-progress]');
    var status = root.querySelector('[data-kit-status]');
    var button = root.querySelector('[data-kit-add]');

    function selectedItems() {
      var items = [];

      root.querySelectorAll('[data-kit-item]:checked').forEach(function (input) {
        items.push(input.dataset.variantId);
      });

      root.querySelectorAll('[data-kit-select]').forEach(function (select) {
        var fieldset = select.closest('fieldset');
        var toggle = fieldset.querySelector('[data-kit-select-toggle]');
        if (toggle && toggle.checked && select.value) items.push(select.value);
      });

      return items;
    }

    function updateProgress() {
      var count = selectedItems().length;
      progress.textContent = count >= 4
        ? count + ' products selected — 10% discount unlocked.'
        : count + ' products selected — add ' + (4 - count) + ' more to unlock 10% off.';
    }

    function updateSelectPreview(select) {
      var preview = select.closest('fieldset').querySelector('[data-kit-select-preview]');
      var option = select.options[select.selectedIndex];
      if (!preview || !option) return;
      preview.src = option.dataset.imageUrl || '';
      preview.alt = option.dataset.imageAlt || '';
      preview.hidden = !option.dataset.imageUrl;
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-kit-select]')) updateSelectPreview(event.target);
      updateProgress();
    });
    root.querySelectorAll('[data-kit-select]').forEach(updateSelectPreview);
    updateProgress();

    button.addEventListener('click', function () {
      var variants = selectedItems();
      if (!variants.length) {
        status.textContent = 'Select at least one product before adding the regimen to your cart.';
        return;
      }

      button.setAttribute('aria-disabled', 'true');
      status.textContent = 'Adding selected products to your cart…';

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: variants.map(function (id) {
            return {
              id: Number(id),
              quantity: 1,
              properties: {
                _kit_id: root.dataset.kitId,
                _kit_name: root.dataset.kitName
              }
            };
          })
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }).then(function () {
        status.textContent = 'Selected products were added to your cart.';
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function () {
        status.textContent = 'We could not add the regimen. Check product availability and try again.';
        button.removeAttribute('aria-disabled');
      });
    });
  }

  document.querySelectorAll('[data-treatment-kit]').forEach(init);
}());
